export default "__VITE_ASSET__DcPbdcxy__"